import React, { useState, useContext } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Button,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { BuildingContext } from "Context/BuildingProvider";
import { useQuery } from "@apollo/client";
import TableLoading from "components/Misc/TableLoading";
import ErrorMessage from "components/Misc/ErrorMessage";
import { GET_TASKS } from "lib/tasks";
import { GetRolesQueryResult, GetTasksQueryResult } from "generated/graphql";
import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import { GET_ROLES } from "lib/roles";
import { OnlineBuildingGuard } from "lib/realtimeDBTypes";

interface TaskSenderProps {
  sendToType: string;
  handleSendToTypeChange: (event: any) => void;
  onlineBuildingGuards: OnlineBuildingGuard[];
  user?: string;
  handleUserChange: (id: string) => void;
  sendTaskToUser: (
    taskId: number,
    buildingGuardId: number,
    taskName: string,
    priority: number
  ) => void;
  sendTaskToRole: (
    taskId: number,
    roleId: string | number | undefined,
    taskName: string,
    priority: number
  ) => void;
}
interface TaskSenderState {
  role?: number | string;
}

const DEFAULT_STATE: TaskSenderState = {
  //sendToType: "Role",
};

export default function TaskSender({
  sendToType,
  user,
  handleSendToTypeChange,
  handleUserChange,
  sendTaskToRole,
  sendTaskToUser,
}: TaskSenderProps) {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [state, setState] = useState<TaskSenderState>(DEFAULT_STATE);
  const { currentBuilding, buildingState } = useContext(BuildingContext);
  const onlineBuildingGuards = buildingState?.onlineBuildingGuards;
  const {
    loading: tasksLoading,
    error,
    data,
  }: GetTasksQueryResult = useQuery(GET_TASKS, {
    variables: {
      buildingId: currentBuilding?.Id,
      limit,
      offset: page,
    },
  });
  const {
    loading: rolesLoading,
    error: rolesError,
    data: rolesData,
  }: GetRolesQueryResult = useQuery(GET_ROLES, {
    variables: {
      buildingId: currentBuilding?.Id,
    },
  });
  const loading = rolesLoading || tasksLoading;
  const handleTaskSend = (
    id: number,
    taskName?: string | null,
    priority?: number | null
  ) => {
    console.log("🚀 ~ file: TaskSender.tsx ~ line 93 ~ priority", priority);
    console.log("🚀 ~ file: TaskSender.tsx ~ line 93 ~ taskName", taskName);
    console.log("🚀 ~ file: TaskSender.tsx ~ line 93 ~ id", id);
    console.log(state);
    console.log(sendToType);
    console.log("user", user);
    if (sendToType === "Role" && taskName) {
      sendTaskToRole(
        id,
        state?.role ? state.role : "Any",
        taskName,
        priority ? priority : 3
      );
    } else if (user && taskName) {
      sendTaskToUser(id, parseInt(user), taskName, priority ? priority : 3);
    } else if (taskName) {
      let defaultValue;
      for (const key in onlineBuildingGuards) {
        defaultValue = key;
      }
      if (defaultValue) {
        sendTaskToUser(
          id,
          parseInt(defaultValue),
          taskName,
          priority ? priority : 3
        );
      }
    }
  };
  const handleLimitChange = (event: any) => {
    setLimit(event.target.value);
  };

  const _handleUserChange = (event: any) => {
    console.log("🚀 ~ file: TaskSender.tsx ~ line 122 ~ event", event);
    handleUserChange(event.target.value);
  };

  const handlePageChange = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleRoleChange = (event: any) => {
    console.log(
      "🚀 ~ file: TaskSender.tsx ~ line 130 ~ handleRoleChange ~ event",
      event
    );
    setState({ ...state, role: event.target.value as number });
  };
  if (loading) {
    return <TableLoading />;
  } else if (error) {
    return <ErrorMessage message={error.message}></ErrorMessage>;
  } else if (!!data?.Task && !!rolesData?.Role) {
    const inputs: ConfigInput[] = [
      {
        title: "Send to User or Role",
        type: "radio",
        options: [
          { label: "Role", value: "Role" },
          { label: "User", value: "User" },
        ],
        onChange: handleSendToTypeChange,
        xs: 12,
        sm: 6,
        id: "sendToType",
        value: sendToType,
      },
    ];

    if (sendToType === "Role") {
      const roles: FormOption[] = [{ label: "Any", value: "Any" }];
      rolesData.Role.forEach((role) => {
        roles.push({
          label: role.Title,
          value: role.Id,
        });
      });
      inputs.push({
        title: "Select Role",
        type: "select",
        onChange: handleRoleChange,
        xs: 12,
        sm: 6,
        id: "selectRole",
        placeholder: "Select a role to send the task to",
        options: roles,
        value: state.role ? state.role : "Any",
      });
    } else if (sendToType === "User" && onlineBuildingGuards) {
      console.log("here");
      const users: FormOption[] = [];
      let defaultValue;
      for (const key in onlineBuildingGuards) {
        defaultValue = key;
        users.push({
          label: onlineBuildingGuards[key].name,
          value: key,
        });
      }
      inputs.push({
        title: "Select User",
        type: "select",
        onChange: (event) => {
          console.log("🚀 ~ file: TaskSender.tsx ~ line 192 ~ event", event);

          _handleUserChange(event);
        },
        xs: 12,
        sm: 6,
        id: "selectUser",
        placeholder: "Select a user to send the task to",
        options: users,
        value: user ? user : defaultValue,
      });
    }

    return (
      <React.Fragment>
        <ConfigForm inputs={inputs}></ConfigForm>
        <Paper className="container">
          <PerfectScrollbar>
            <Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Priority</TableCell>
                    <TableCell>Send</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.Task.slice(0, limit).map((task) => (
                    <TableRow hover key={task.Id}>
                      <TableCell component="th" scope="row">
                        {task.Name}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {task.Priority}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => {
                            handleTaskSend(task.Id, task.Name, task.Priority);
                          }}
                        >
                          Send Task
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination
            component="div"
            count={
              data?.Task_aggregate.aggregate?.count
                ? data?.Task_aggregate.aggregate?.count
                : 0
            }
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Paper>
      </React.Fragment>
    );
  } else {
    return <div>No Tasks</div>;
  }
}
